import {
  useSystemHealthSummaryQuery,
  useSystemHealthActivityQuery,
  useSystemHealthStatsQuery,
} from '../../../hooks/admin/useSystemHealth'
import { HealthBanner } from './HealthBanner'
import { ActivitySection } from './ActivitySection'
import { DailyStatsSection } from './DailyStatsSection'
import { AlertSettingsSection } from './AlertSettingsSection'
import { AlertRecipientsSection } from './AlertRecipientsSection'
import { ProcessorBuildStrip } from './ProcessorBuildStrip'
import { FailedMessagesSection } from './FailedMessagesSection'

/**
 * The original System Health page body, lifted verbatim so the view is
 * unchanged apart from now living under a tab.
 *
 * Keeping the polling queries here rather than on the page shell is deliberate:
 * switching to the Endpoints tab unmounts this component, which stops the three
 * refetch intervals instead of leaving them running behind a hidden tab.
 */
export function OverviewTab() {
  const { data: summary, isLoading: isLoadingSummary } = useSystemHealthSummaryQuery()
  const { data: activity, isLoading: isLoadingActivity } = useSystemHealthActivityQuery()
  const { data: stats, isLoading: isLoadingStats } = useSystemHealthStatsQuery()

  return (
    <div className="space-y-6">
      <p className="text-sm text-gray-600">
        Live status of the Sigfox message-processing pipeline.
      </p>

      <HealthBanner summary={summary} isLoading={isLoadingSummary} />
      <ProcessorBuildStrip />
      <FailedMessagesSection />
      <ActivitySection activity={activity} isLoading={isLoadingActivity} />
      <DailyStatsSection stats={stats} isLoading={isLoadingStats} />

      <div className="border-t border-gray-200 pt-6 space-y-8">
        <AlertSettingsSection />
        <AlertRecipientsSection />
      </div>
    </div>
  )
}
